// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"590":"6061a1e1","713":"d8019c34","910":"2807da97","948":"2807da97","978":"2807da97","997":"30b8cefb"}[chunkId] + ".chunk.css";
};